// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  callId: __t.u64().primaryKey().name("call_id"),
  battleId: __t.u64().name("battle_id"),
  warId: __t.u64().name("war_id"),
  worldId: __t.u64().name("world_id"),
  side: __t.string(),
  wanted: __t.u32(),
  sent: __t.u32(),
  round: __t.u32(),
  state: __t.string(),
  calledAt: __t.timestamp().name("called_at"),
});
